<template>
  <div class="route-view dark" :class="hasTop ? 'has-top' : ''">
    <language-switch />
    <div class="logo">
      <img src="/images/logo.png" />
    </div>
    <div class="section-title"></div>
    <div class="desc">
      <img v-if="lineQR" :src="lineQR" class="qr-code" />
      <div class="detail">
        <div v-html="contactText"></div>
        <div class="version">Version {{ appVersion }}</div>
        <span v-if="enableChatWidget != null && !enableChatWidget">
          <i v-if="lineName" class="fab fa-line"></i>&nbsp;&nbsp;
          <a :href="lineLink" target="_blank">{{ lineName }}</a>
        </span>
      </div>
    </div>
    <div v-if="enableChatWidget" class="widget">
      <widget />
    </div>
  </div>
</template>

<script>
import { version } from '../../package'
import apiLookup from '@/api/lookup'
import Widget from '@/components/widget'
import i18n from '@/language'
import LanguageSwitch from '@/components/LanguageSwitch'

export default {
  name: 'UserHelp',
  components: {
    Widget,
    LanguageSwitch
  },
  props: {
    page: String,
    hasTop: Boolean
  },
  data() {
    return {
      contactText: '',
      lineQR: '',
      lineLink: '',
      lineName: '',
      appVersion: version,
      enableChatWidget: false,
      name: i18n.t('bottomMenu.contact')
    }
  },
  created() {
    this.$emit('childinit', this.page)
  },
  mounted() {
    this.lookupContact()
  },
  methods: {
    i18n() {
      return i18n
    },
    async lookupContact() {
      const contact = await apiLookup.lookupContact()

      if (process.env.VUE_APP_BASE_CHATBACKEND) {
        const result = await apiLookup.lookupEnableChatWidget()
        this.enableChatWidget = result.enableChatWidget
      }

      this.contactText = contact.contactText
      this.lineLink = contact.lineLink
      this.lineName = contact.lineName

      if (contact.lineQR) {
        this.lineQR = `${process.env.VUE_APP_BASE_API.replace('/api', '')}${
          contact.lineQR
        }?ts=${new Date().getTime()}`
      } else {
        const imgUrl = '/images/line-qr-code.png'
        const image = new Image()
        image.src = imgUrl

        if (image.width > 0) this.lineQR = imgUrl
        else this.lineQR = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.desc {
  margin: 30px 0;
  text-align: center;

  img.qr-code {
    width: 250px;
  }

  .detail {
    font-size: 18px;
    margin: 10px 0;

    a {
      font-size: 20px;
      &:hover {
        color: $text-color;
        opacity: 0.7;
      }
    }
  }
  .fa-line {
    margin-top: 20px;
    font-size: 30px;
    color: #00b900;
    background-color: white;
    line-height: 0.6;
  }
}
.widget {
  z-index: 999;
}
.version {
  font-size: 12px;
}
</style>
